'use client'

import React, { useCallback, useEffect, useState } from 'react'
import NextLink from 'next/link'
import NextImage from 'next/image'

import Button from '@/components/Button'
import {
	LeftArrowIcon,
	LinkIcon,
	MailIcon,
	RightArrowIcon,
	TelegramIcon,
	UpRightArrowIcon,
	VkIcon
} from '@/components/Icon'
import Typography from '@/components/Typography'

import styles from '../../styles.module.css'
import IconButton from '@/components/IconButton'
import useEmblaCarousel from 'embla-carousel-react'
import { EmblaCarouselType } from 'embla-carousel'
import ShareSection from '../ShareSection'
import Link from '@/components/Link'
import ImagesCarousel from '../ImagesCarousel'
import ArticleImages from '../ArticleImages'

const similarCases: any[] = [
	// {
	//   img: "/passport.jpeg",
	//   href: "#",
	//   badge: "Образование",
	//   title: "Внедрение искусственного интеллекта (AI)",
	//   description:
	//     "Сервис для создания сопроводительного письма в иммиграционную службу",
	// },
	// {
	//   img: "/vehicle.png",
	//   href: "#",
	//   badge: "Производство",
	//   title: "Цифровизация завода",
	//   description:
	//     "Крупнейший производитель вездеходов в Восточной Сибири и на Дальнем Востоке",
	// },
]

export default function Article10() {
	return (
		<>
			<article className={styles.article}>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Задачи
					</Typography>
					<ol className={styles.article__ol}>
						<li className={styles.article__ol__item}>
							<Typography variant='h3' className={styles.article__ol__label} color='accent'>
								1
							</Typography>
							<Typography variant='p1' className={styles.article__ol__text}>
								С помощью SMM сделать бренд «Money Roses» лидером в премиальном ценовом сегменте в городе
								пребывания
							</Typography>
						</li>
						<li className={styles.article__ol__item}>
							<Typography variant='h3' className={styles.article__ol__label} color='accent'>
								2
							</Typography>
							<Typography variant='p1' className={styles.article__ol__text}>
								Разработать и реализовать SMM-стратегию профиля в Instagram, познакомить пользователей с
								компанией, донести до них преимущества
							</Typography>
						</li>
						<li className={styles.article__ol__item}>
							<Typography variant='h3' className={styles.article__ol__label} color='accent'>
								3
							</Typography>
							<Typography variant='p1' className={styles.article__ol__text}>
								Повысить узнаваемость и запоминаемость бренда, создать у целевой аудитории ассоциацию бренда с
								качеством, хорошим сервисом и стилем, вниманием и заботой
							</Typography>
						</li>
						<li className={styles.article__ol__item}>
							<Typography variant='h3' className={styles.article__ol__label} color='accent'>
								4
							</Typography>
							<Typography variant='p1' className={styles.article__ol__text}>
								Помочь клиенту увеличить количество продаж
							</Typography>
						</li>
					</ol>
				</section>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Что сделали
					</Typography>
					<Typography variant='h3' className={styles.article__headline}>
						1. Провели аудит и сегментировали аудиторию
					</Typography>
					<Typography variant='p1'>
						Провели аудит Instagram-аккаунта, составили список рекомендаций и разработали стратегию продвижения.
						Изучили целевую аудиторию, сегментировали ее по возрасту, полу, интересам, болям и потребностям для
						запуска таргетированной рекламы и создания SMM-стратегии. В результате у нас получилось 8 портретов
						мужчин и женщин, на которых потом запустили рекламу.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/10-1.png').default,
								placeholder: 'blur'
							}
						]}
						fullWidth
					/>
					<Typography variant='h3' className={styles.article__headline}>
						2. Создали визуальное оформление профиля
					</Typography>
					<Typography variant='p1'>
						Подготовили текст для шапки профиля в Instagram, разработали highlights с адресами салонов, отзывами и
						вариантами цветочных композиций разной тематики. Например, с букетами для невест. Также разработали
						сетку с фотографиями, которые сочетаются друг с другом. Для оформления профиля использовали не только
						цветы, но и фото реальных покупателей и подписчиков. Пользователям больше нравится контент с живыми
						людьми, будь то фото или видео. Поэтому мы часто приглашали пользователей на TFP-фотосессии в Stories
						аккаунта.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/10-2.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
					<Typography variant='h3' className={styles.article__headline}>
						3. Разработали контент-стратегию
					</Typography>
					<Typography variant='p1'>
						Разделили публикации в ленте и активности в Stories по видам контента на информационные, вовлекающие и
						продающие, имиджевые и ситуативные, чтобы провести подписчиков по всем этапам воронки продаж.
						Например: мероприятия в салонах, интересные факты про цветы, конкурсы и розыгрыши, подборки букетов по
						ценовым категориям или к тематическим праздникам.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/10-3.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/10-4.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/10-5.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/10-6.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/10-7.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/10-8.png').default,
								placeholder: 'blur'
							}
						]}
					/>
					<Typography variant='p1'>
						Для того, чтобы люди не забывали о важности дарить друг другу цветы по поводу и без – напоминаем им об
						этом ежедневными публикациями. Также начали тестирование Reels, так как по статистике люди
						просматривают Reels намного чаще, чем посты, Stories, видео или даже IGTV.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/10-9.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/10-10.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/10-11.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/10-12.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/10-13.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/10-14.png').default,
								placeholder: 'blur'
							}
						]}
					/>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h3' className={styles.article__headline}>
						4. Запустили таргетированную рекламу
					</Typography>
					<Typography variant='p1'>
						Перед запуском разработали майндмэп, где расписали сегменты целевой аудитории и концепции для
						цепляющих нашу ЦА креативов. Рекламу запустили разных форматов: сторис, промо-посты, карусели и
						имиджевые посты из ленты. В креативах использовали фото, видео и анимацию. Целью рекламной кампании
						задали клики по ссылке, которая вела в профиль клиента.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/10-15.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h3' className={styles.article__headline}>
						5. Сделали коллаборации и розыгрыши
					</Typography>
					<Typography variant='p1'>
						Периодически проводим совместные активности с брендами и блогерами, у которых схожая ЦА. 1-2 раза в
						месяц разыгрываем букеты для привлечения новых подписчиков, повышения лояльности и активности в
						профиле. Например, уже организовали коллаборации с рестораном «Мираж» и брендом косметики «Tony Moly».
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/10-16.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
				</section>

				<section className={`${styles.article__section} ${styles.article__section__results}`}>
					<Typography variant='h2' className={styles.article__headline}>
						Результаты
					</Typography>
					<div className={styles.article__results}>
						<section className={styles.article__results__section}>
							<Typography variant='h3'>25%</Typography>
							<Typography variant='h5' color='description'>
								рост охвата профиля в Instagram
							</Typography>
						</section>
						<section className={styles.article__results__section}>
							<Typography variant='h3'>38%</Typography>
							<Typography variant='h5' color='description'>
								рост прибыли клиента
							</Typography>
						</section>
						<section className={styles.article__results__section}>
							<Typography variant='h3'>10</Typography>
							<Typography variant='h5' color='description'>
								покупок через социальные сети ежедневно
							</Typography>
						</section>
					</div>
				</section>
				<ShareSection />
			</article>

			{similarCases.length > 0 && (
				<section className={`${styles.similar__projects}`}>
					<Typography variant='h2'>Похожие проекты</Typography>
					<div className={`${styles.cases__cards}`}>
						{similarCases.slice(0).map(({ img, href, badge, description, title }, idx) => (
							<div className={styles.case} key={idx}>
								<div className={styles.card}>
									<NextImage
										className={styles['card-image']}
										src={img}
										alt=''
										fill
										priority
										sizes='(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw'
									/>
									<div className={styles.badge}>{badge}</div>
									<div className={styles['card-hover']}>
										<div className={styles['card-hover__content']}>
											<span className={styles['card-hover__text-small']}>Ознакомиться с кейсом</span>
											{/* <span className={styles["card-hover__text-big"]}>x3</span>{" "}
                      <span className={styles["card-hover__text-small"]}>
                        Рост конверсии
                      </span>
                      <span className={styles["card-hover__text-big"]}>60</span>{" "}
                      <span className={styles["card-hover__text-small"]}>
                        Часов работы
                      </span> */}
											<IconButton
												Icon={UpRightArrowIcon}
												variant='circle'
												className={styles['card-hover__button']}
											/>
										</div>
									</div>
								</div>
								<Typography variant='h5' className={styles.case__headline}>
									{title}
								</Typography>
								<Typography variant='p2' color='description' className={styles.case__description}>
									{description}
								</Typography>
							</div>
						))}
					</div>
				</section>
			)}
		</>
	)
}
